import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import { Controller, EffectFlip, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import gsap from 'gsap'
import 'swiper/css'
import 'swiper/css/effect-flip'
import 'swiper/css/effect-fade'
import { CloudinaryContext, Video} from 'cloudinary-react';
import Marquee from 'react-fast-marquee'

import Base from 'components/Layout/Base'
import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import Fade from 'components/utils/ContentReveal'
import { TextVampiroOne } from 'components/utils/FontSpan'
import LogoX from 'images/logo-x.inline.svg'
import Background from 'components/Pages/Home/Background'
import Brands from 'components/Pages/Home/Brands'

const Home = ({ location, data }) => {

  const division = data.allStrapiSpeaker.edges.length / 3
  const speakerLine1 = [...data.allStrapiSpeaker.edges].slice(0,division )
  const speakerLine2 = [...data.allStrapiSpeaker.edges].slice(division, division*2 )
  const speakerLine3 = [...data.allStrapiSpeaker.edges].slice(division*2, division*3 )

  useEffect(() => {
    gsap.from('.logo-x-hero', {
      opacity: 0,
      scale: 0.3,
      duration: 1,
      delay: location.state && location.state.source === 'internal' ? 0.6 : 1.5 
    })
  },[])

  const [controlledSwiper, setControlledSwiper] = useState(null);
  const [my_swiper, set_my_swiper] = useState({})

  const nextSlide = () => my_swiper.slideNext()
  const prevSlide = () => my_swiper.slidePrev()

  const sponsorOrder = ['Presenting Sponsor','Official Sponsor','Co-Supporting Sponsors','Partners','Media Partners']
  data.allStrapiSponsorCategory.edges.sort( (a,b) => sponsorOrder.indexOf(a.node.Name) - sponsorOrder.indexOf(b.node.Name) )

  return (
    <Base pageTitle="Home" background={ <Background location={ location }/>} location={ location } footerButtonColor="var(--id-blue)" >
      <section className="-mt-32 md:-mt-36">
        <ResponsiveContainer className="h-screen pt-32 flex flex-col items-center justify-center md:flex-row md:justify-around md:pt-36">
          <LogoX className="logo-x-hero opacity-100 w-44 h-auto sm:w-80 md:w-auto md:h-40 md:ml-52" />
          <a href="https://www.jagat.live/" className="bg-white text-id-blue text-lg font-bold uppercase px-6 py-3 mt-8 md:mx-24 md:mt-0 md:text-2xl">Enter Ideafest 2021</a>
        </ResponsiveContainer>
      </section>
      <section>
        <ResponsiveContainer className="py-12">
          <div className="flex flex-col mb-24 md:flex-row md:justify-between">
            <div className="mb-16 md:w-5/12 md:mb-0 md:flex-none">
              <Fade>
                <h3 className="text-2xl leading-7 mb-4 "><TextVampiroOne>A</TextVampiroOne>bout Ideafest</h3>
                <p>IdeaFest is the biggest creative festival in Indonesia where disruptive and trendsetting individuals share, discuss, and provoke fresh and insightful ideas. In its tenth anniversary, IdeaFest is set to become a creative hub where all stakeholders in the creative industry gather to grow budding talents and build an ecosystem that could weather whatever the future might bring.</p>
              </Fade>
            </div>
            <div className="md:w-5/12 md:flex-none">
              <Fade>
                <h3 className="text-minecraft text-2xl leading-7 mb-4 ">18-28.11.2021</h3>
                <h2 className="text-5xl font-bold md:-mt-1 lg:text-6xl xl:text-7xl">Face the Unexpected</h2>
              </Fade>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <div className="mb-16 md:w-5/12 md:mb-0 md:flex-none">
              <Fade>
                <CloudinaryContext cloudName="psnug" secure> 
                  <Video  publicId="v1634863360/ideafest-2021/ideafest-2020-vid_jld0ww" controls={ true } width="100%" className="h-60 md:h-40 lg:h-60 xl:h-96"/>
                </CloudinaryContext>
                <h3 className="text-optician-sans uppercase text-center mt-4">Previous Event</h3>
              </Fade>
            </div>
            <div className="md:w-5/12 md:flex-none">
              <Fade>
                <div className="mb-16">
                  <h3 className="text-optician-sans mb-4 uppercase text-2xl">Vision &amp; Mission</h3>
                  <p>IdeaFest aims to bring people from multi-creative disciplines together in one virtual hub. Creating an inclusive space where they can converse and inspire each other without limitations, paving the way for groundbreaking ideas that will shape the future.</p>
                  <p>IdeaFest exists to be a creative haven that connects and empower the nation's creative communities, so they can unleash their growth potentials and go beyond what's possible.</p>
                </div>
              </Fade>
              <Fade>
                <div>
                  <h3 className="text-optician-sans mb-4 uppercase text-2xl">This Year's Theme</h3>
                  <p>The x-factor might stand for an uncertain future that might throw a wrench into our plan, but it also stands for the unlimited possibilities that enable us to go where no one has gone before. IdeaFest invites you to look at the x-factor in a new light, embracing the unknown and harnessing its power to map out the uncharted territory of the future. This year, let's discover how the x-factor can empower you.</p>
                </div>
              </Fade>
            </div>
          </div>
        </ResponsiveContainer>
      </section>
      <Marquee gradientWidth={0} speed={25} className="overflow-hidden mb-8" >
      <>
          <span className="text-4xl font-bold"><span className="text-minecraft">T</span>ablo&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-vampiro-one">S</span>tefan <span className="text-ark-es">S</span>agmeister&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-minecraft">G</span>ita <span className="text-vampiro-one">W</span>irjawan&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-ark-es">R</span>affi <span className="text-minecraft">A</span>hmad&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-vampiro-one">R</span>idwan <span className="text-ark-es">K</span>amil&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-minecraft">D</span>aito <span className="text-vampiro-one">M</span>anabe&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-ark-es">W</span>icky <span className="text-minecraft">V</span>. <span className="text-vampiro-one">O</span>lindo&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-vampiro-one">R</span>eza <span className="text-ark-es">S</span>ervia&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-minecraft">A</span>hmad <span className="text-vampiro-one">I</span>zham <span className="text-ark-es">O</span>mar&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-minecraft">T</span>retan <span className="text-vampiro-one">M</span>uslim&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-ark-es">P</span>atrick <span className="text-minecraft">E</span>ffendy&nbsp;/&nbsp;</span>
          <span className="text-4xl font-bold"><span className="text-vampiro-one">J</span>ovial <span className="text-ark-es">D</span>a <span className="text-minecraft">L</span>opez&nbsp;/&nbsp;</span>
        </>
        {speakerLine1.map( item => {
          const fullname = item.node.Name.split(' ').map( item => {
            const char = [...item]
            const textClass = ['text-vampiro-one','text-minecraft','text-ark-es']
            const classIndex = Math.floor(Math.random() * 3)
            return (
              <>
                <span className={ textClass[classIndex] }>{ char[0] }</span>{ [...char.slice(1)] }
              </>
            )
          })

          return <span className="text-4xl font-bold">{ fullname.map( item => <>{item}&nbsp;</>) }/&nbsp;</span>
        } )}
      </Marquee>
      <Marquee gradientWidth={0} speed={25} direction={'right'} className="overflow-hidden mb-8">
        <span className="text-4xl font-bold"><span className="text-minecraft">B</span>rian <span className="text-vampiro-one">M</span>cGinn&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">D</span>ian <span className="text-minecraft">S</span>astrowardoyo&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">C</span>hitra <span className="text-ark-es">S</span>ubyakto&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">I</span>MCMPLX&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">S</span>al <span className="text-ark-es">P</span>riadi&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">M</span>ax <span className="text-vampiro-one">M</span>andias&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">T</span>oni <span className="text-minecraft">D</span>arusman&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">J</span>ason <span className="text-ark-es">I</span>skandar&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">D</span>esi <span className="text-vampiro-one">A</span>nwar&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">I</span>nez <span className="text-minecraft">K</span>ristanti&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">D</span>endy <span className="text-ark-es">D</span>arman&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">N</span>aufal <span className="text-vampiro-one">A</span>bshar&nbsp;/&nbsp;</span>
        {speakerLine2.map( item => {
          const fullname = item.node.Name.split(' ').map( item => {
            const char = [...item]
            const textClass = ['text-vampiro-one','text-minecraft','text-ark-es']
            const classIndex = Math.floor(Math.random() * 3)
            return (
              <>
                <span className={ textClass[classIndex] }>{ char[0] }</span>{ [...char.slice(1)] }
              </>
            )
          })

          return <span className="text-4xl font-bold">{ fullname.map( item => <>{item}&nbsp;</>) }/&nbsp;</span>
        } )}
      </Marquee>
      <Marquee gradientWidth={0} speed={25} className="overflow-hidden mb-8" >
      <span className="text-4xl font-bold"><span className="text-minecraft">D</span>ena <span className="text-vampiro-one">R</span>achman&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">M</span>ichael <span className="text-minecraft">K</span>illian&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">J</span>ennifer <span className="text-ark-es">K</span>arjadi&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">L</span>ala <span className="text-vampiro-one">B</span>ohang&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">A</span>treyu <span className="text-minecraft">M</span>oniaga&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">W</span>regas <span className="text-ark-es">B</span>hanuteja&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">D</span>imas <span className="text-vampiro-one">D</span>jayadiningrat&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">R</span>aden <span className="text-vampiro-one">P</span>risya&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-ark-es">L</span>omba <span className="text-minecraft">S</span>ihir&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-vampiro-one">K</span>unto <span className="text-ark-es">A</span>ji&nbsp;/&nbsp;</span>
        <span className="text-4xl font-bold"><span className="text-minecraft">B</span>asboi&nbsp;/&nbsp;</span>
        {speakerLine3.map( item => {
          const fullname = item.node.Name.split(' ').map( item => {
            const char = [...item]
            const textClass = ['text-vampiro-one','text-minecraft','text-ark-es']
            const classIndex = Math.floor(Math.random() * 3)
            return (
              <>
                <span className={ textClass[classIndex] }>{ char[0] }</span>{ [...char.slice(1)] }
              </>
            )
          })

          return <span className="text-4xl font-bold">{ fullname.map( item => <>{item}&nbsp;</>) }/&nbsp;</span>
        } )}
      </Marquee>
      <section>
        <ResponsiveContainer className="py-12">
          <TitleSwiper slidesPerView={1} modules={[Controller, EffectFlip]} onSwiper={setControlledSwiper} effect="flip" height="120" direction="vertical" loop className="mb-24">
            { data.allStrapiProgram.edges.map( (item, index) => {
                return (
                  <SwiperSlide key={ index }>
                    <div className="text-center h-full">
                      <img src={ item.node.Logo.url } alt={ item.node.Title } className="h-auto max-h-full w-auto max-w-full inline-block" />
                    </div>
                  </SwiperSlide>
                )
              })}
          </TitleSwiper>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-8 md:w-5/12 md:mb-0 md:flex-none md:order-2">
              <Swiper
                modules={[Controller, Pagination]}
                controller={{ control: controlledSwiper }}
                pagination={{ el: '.custom-pagination'}}
                onInit={(ev) => set_my_swiper(ev)}
                loop
              >
                { data.allStrapiProgram.edges.map( (item, index) => {
                  return (
                    <SwiperSlide key={ index }>
                      <h3 className="text-optician-sans mb-4 text-xl">{ new Date(item.node.StartDate).getDate() }{ item.node.EndDate && <> - { new Date(item.node.EndDate).getDate() }</> } { new Date(item.node.StartDate).toLocaleString('default', { month: 'long' }) }</h3>
                      <p>{ item.node.ShortDescription }</p>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
            <div className="flex items-center justify-center md:w-5/12 md:flex-none md:order-1">
              <button className="text-xl" onClick={prevSlide} aria-label="Previous"><FaChevronLeft /></button>
              <CustomPagination className="custom-pagination" />
              <button className="text-xl" onClick={nextSlide} aria-label="Next"><FaChevronRight /></button>              
            </div>
          </div>          
        </ResponsiveContainer>
      </section>
      { data.allStrapiSponsorCategory.edges.map( (item, index) => <Brands label={ item.node.Name } data={ item.node.sponsors } key={`brand-${index}`} /> )}
    </Base>
  )
}

const TitleSwiper = styled(Swiper)`
  height: 64px;
  .swiper-slide-shadow-top,
  .swiper-slide-shadow-bottom {
    display: none !important;
  }
`
const CustomPagination = styled.div`
  display: flex;
  margin-left: 1rem;
  margin-right: 1rem;
  .swiper-pagination-bullet{
    width: 10px;
    height: 10px;
    border: 2px solid white;
    border-radius: 99px;
    background: transparent;
    margin-left: 3px;
    margin-right: 3px;
  }
  .swiper-pagination-bullet-active {
    background: white;
  }
`

export const query = graphql`
  query HomeQuery {
    allStrapiProgram(filter: {Title: {nin: "Xperiential Booth"}}) {
      edges {
        node {
          Title
          Logo {
            url
          }
          StartDate
          id
          ShortDescription
          EndDate
        }
      }
    }
    allStrapiSpeaker(filter: {Highlight: {eq: true}}) {
      edges {
        node {
          Name
          id
        }
      }
    }
    allStrapiSponsorCategory {
      edges {
        node {
          sponsors {
            Logo {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 300, quality: 100, formats: WEBP)
                }
              }
            }
            Title
            URL
            id
          }
          Name
          id
        }
      }
    }
  }
`

export default Home